<div *ngIf="showTeams" class="row teams-overview-body justify-content-center">
  <app-analyse></app-analyse>
</div>
